import { HIDE_MODAL, SHOW_MODAL } from './modalAction'

const initModalState = {
  modalType: null,
}

export default (state = initModalState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        isActive: true,
        modalType: action.modalType,
        openParams: action.params
      }
    case HIDE_MODAL:
      return {
        ...state,
        isActive: false,
        modalType: null,
        closeParams: action.params
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/redux-modal/redux/modalReducer.js